// src/services/supportService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const supportApi = axios.create({
  baseURL: `${API_URL}/api/v1/support`,
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000
});

// Attach token if present (contact form works both for guests and logged-in users)
supportApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('kapta_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const supportService = {
  /**
   * Submit a contact form message.
   * @param {Object} payload - { name, email, phone?, subject, message }
   */
  async submitContact(payload) {
    try {
      const res = await supportApi.post('/contact', payload);
      return res.data;
    } catch (error) {
      const message =
        error.response?.data?.message ||
        error.message ||
        'Failed to submit your message';
      throw new Error(message);
    }
  }
};

export default supportService;